Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.GroupedElementsSelectView extends Backbone.View
  className: 'tags-group-filter'
  template: JST["backbone/templates/monitoring/filters/grouped_elements/grouped_elements_select"]

  events:
    'change select.elements': 'onAddElement'
    'click li.listed-element': 'onRemoveElement'
    'change .logic-label': 'onChangeLogic'
    'click #clear-elements-from-list': 'clearAll'
    'change #only-present-elements': 'onChangeOnlyPresentElements'

  initialize: ({id, possibleElements, appliedElements, title, logic, canFilterOnlyPresent}) ->
    @id = id
    @possibleElements = possibleElements
    @appliedElements = appliedElements
    @title = title
    @logic = logic
    @disabled = false # true when other view has a custom tag (allTags, noTags)
    @onlyPresentElements = false
    @canFilterOnlyPresent = canFilterOnlyPresent

  render : ->
    @$el.html(@template(@))
    @initializeChosen()
    @

  initializeChosen: ->
    select = @$el.find('select.elements')
    select.chosen({width: '200px', search_contains: true})
    chosenDrop = @$el.find('.chosen-drop').hide()
    select.on('chosen:showing_dropdown', -> chosenDrop.show())
    select.on('chosen:hiding_dropdown', -> chosenDrop.hide())

  onAddElement: (evt) ->
    @trigger('GroupedElementsSelectView:onChange')
    code = $(evt.currentTarget).val()
    if code in @possibleCustomNames()
      @onAddCustomElement(code)
    else
      @addElement(code)
      @render()
      @trigger('GroupedElementsSelectView:onChange')


  _swalTitle: () ->
    ''

  onAddCustomElement: (code) ->
    swal({
      title: @_swalTitle(),
      type: 'info',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Ok',
      closeOnConfirm: true
    }, (isConfirm) =>
      if (isConfirm)
        @clearAll()
        @trigger('removed:customElement')
        @addElement(code)
        @trigger('added:customElement')
        @trigger('GroupedElementsSelectView:onChange')
    )

  addElement: (code) ->
    _.each(@possibleElements, (element) =>
      if code == element.term
        element.applied = true
        @appliedElements.push(element)
    )

  onRemoveElement: (evt) ->
    code = $(evt.currentTarget).data('code').toString()
    if code in @possibleCustomNames()
      @onRemoveCustomElement(code)
    else
      @removeElement(code)
      @render()
    @trigger('GroupedElementsSelectView:onChange')

  onRemoveCustomElement: (code) ->
    @removeElement(code)
    @trigger('removed:customElement')

  removeElement: (code) ->
    _.each(@possibleElements, (element) =>
      if code == element.term
        element.applied = false
        @appliedElements = _.without(@appliedElements, element)
    )

  disable: ->
    @disabled = true
    @render()

  enable: ->
    @disabled = false
    @render()

  onChangeOnlyPresentElements: ->
    @onlyPresentElements = !@onlyPresentElements
    @render()
    @trigger('GroupedElementsSelectView:onChange')

  clearAll: ->
    @appliedElements = []
    _.each(@possibleElements, (tag) -> tag.applied = false)
    @trigger('activate')
    @render()
    @trigger('GroupedElementsSelectView:onChange')

  onChangeLogic: (evt) ->
    @logic = if @logic == 'AND' then 'OR' else 'AND'
    @render()
    @trigger('GroupedElementsSelectView:onChange')

  elementName: (element) ->
    return 'TODO' unless element # TODO where is this function called without params??
    element.description || element.term

  elementNameWithCounter: (element) ->
    @elementName(element) + if element.custom then "" else " (#{element.count})"
